import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HistoricDemoComponent } from './demo/historic-demo/historic-demo.component';
import { AccessLocatorComponent } from './tabs/access-locator/access-locator.component';
import { RecoverMailComponent } from './tabs/recover-mail/recover-mail.component';
import { LoginComponent } from './tabs/login/login.component';
import { BookListComponent } from './tabs/book-list/book-list.component';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'book-pdf', redirectTo: '/acceso', pathMatch: 'full' },
  { path: 'historic', component: HistoricDemoComponent },
  { path: 'acceso', component: AccessLocatorComponent },
  { path: 'recovermail', component: RecoverMailComponent },
  { path: 'bookList', component: BookListComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/login', pathMatch: 'full'},
  { path: '**', redirectTo: '/login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
